// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchSellerRecordResultsByIdParams = {
    authToken: string,
    deployment: string,
    sellerId: number,
};

export default {
    fetchSellerRecordResultsById: ({ authToken, deployment, sellerId }: FetchSellerRecordResultsByIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                authToken,
                deployment,
                path: `<ITEM-API>spa/small/seller/${sellerId}/recordResults`,
            });
            request.end((err, response) => {
                return handleResponseOld({ err, reject, resolve, response });
            });
        }),
};
